import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="routine-schedule"
export default class extends Controller {
  connect() {
  }
}
